import Input, { InputType } from 'components/shared/inputs/input'
import useTranslation from 'utils/hooks/useTranslation'
import * as dd from 'constants/dropdown'
import { convertToSelect } from 'utils'
import { useEffect } from 'react'

type HeatModeDeperditionsConnuesProps = {
  control: any
  errors: any
  calculateDeperd: () => void
  watch?: any
}

const HeatModeDeperditionsDPE: React.FC<HeatModeDeperditionsConnuesProps> = (props) => {
  const { t } = useTranslation()
  const temperatures = convertToSelect(dd.temperature)
  const [temp, dpe] = props.watch(['heatMode.deperditions.temperature', 'heatMode.deperditions.dpe']) //NOSONAR

  useEffect(() => {
    props.calculateDeperd() //NOSONAR
  }, [temp, dpe]) //NOSONAR

  return (
    <>
      <group data-gap="20" data-space="10" data-space-left='0'>
        <group data-length='forcefit-1000' data-fit="1" >
          <Input
            dataLength="autofit"
            dataMaxLength='350'
            type={InputType.Number}
            control={props.control}
            name="heatMode.deperditions.dpe"
            label={`${t('DPE')}`}
            translateLabel={false}
            requiredLabel={true}
            size="large"
            //placeholder={`${t('DPE')}`}
            min={1}
          />
        </group>
      </group>

    </>
  )
}

export default HeatModeDeperditionsDPE
